import React from "react";
import { CONTACT, NAV_LINKS, IMAGES } from "../mock";
import { Twitter, Instagram, Linkedin, Mail, Globe, MapPin, Phone } from "lucide-react";
import AppBadges from "./AppBadges";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#07090a] pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <img src={IMAGES.logo} alt="InstantDrive" className="h-12 w-auto" />
            <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
              Nigeria&apos;s smarter way to move. Verified drivers, upfront pricing
              and cashless rides — a proudly indigenous company launching across Nigeria.
            </p>
            <div className="mt-6"><AppBadges showNote={false} /></div>
          </div>

          <div>
            <h4 className="font-display font-bold text-white uppercase text-sm tracking-wider">Explore</h4>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/60 hover:text-[#2fd645] transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white uppercase text-sm tracking-wider">Contact</h4>
            <ul className="mt-4 space-y-3 text-white/60">
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#2fd645]" /> {CONTACT.location}</li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#2fd645]" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-[#2fd645]">{CONTACT.email}</a></li>
              <li className="flex items-center gap-2"><Globe className="h-4 w-4 text-[#2fd645]" /> {CONTACT.site}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#2fd645]" /> {CONTACT.phone}</li>
            </ul>
            <div className="mt-5 flex gap-3">
              {[
                { Icon: Twitter, label: "Twitter" },
                { Icon: Instagram, label: "Instagram" },
                { Icon: Linkedin, label: "LinkedIn" },
              ].map(({ Icon, label }) => (
                <a key={label} href="#" aria-label={label} className="h-10 w-10 rounded-xl border border-white/10 bg-white/5 flex items-center justify-center text-white/70 hover:text-[#2fd645] hover:border-[#2fd645]/40 transition-colors">
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/45">© 2026 InstantDrive. Built for the future of mobility in Nigeria.</p>
          <div className="flex items-center gap-6 text-sm text-white/45">
            <a href="#" className="hover:text-[#2fd645]">Privacy Policy</a>
            <a href="#" className="hover:text-[#2fd645]">Terms of Service</a>
            <span className="text-[#2fd645] font-semibold">{CONTACT.tagline}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
